import { createContext } from 'react'
import { DynamicContext, defaultDynamicContext } from './DynamicContext.types'

export const dynamicContext = createContext<DynamicContext>(defaultDynamicContext)
